<template>
  <b-container fluid id="main-container">
  <div id="login">
    <h3>Login user</h3>
    <b-form @submit="login">
      <b-form-group class="input-group-admin" label="Email">
        <b-form-input
          required
          type="text"
          v-model="email"
          placeholder="Enter email"
          @blur="validateEmail"
          
        ></b-form-input>
      </b-form-group>

      <b-form-group class="input-group-admin" label="Password">
        <b-form-input
          required
          type="password"
          v-model="password"
          placeholder="Enter password"
          
        ></b-form-input>
      </b-form-group>
      <div class="center-button">
        <b-button pill v-on:click="login" id="button-login" type="button" variant="dark">Login</b-button>  
      </div>
    </b-form>
    <div class="error"><p>{{error}}</p></div>
  </div>
  </b-container>
</template>
<script>
  export default {
    name: "LoginComponent",
    data(){
      return {
        email : "",
        password : "",
        error: "",
      }
    },
    methods: {
      login: function () {
        let data = {
          email: this.email,
          password: this.password,
        }
        if (this.validateEmail()) {
          this.$store.dispatch('login', data)
         .then(() => this.$router.push('/'))
         .catch(err => this.error = err)
        }
      },

      validateEmail() {
        if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
            this.error = 'Please enter a valid email address!';
            return false;
        }
        else {
            this.error = '';
            return true;
        }

      }
    }
  }
</script>

<style>

h3{
  text-align: center;
  margin-top:20px;
}

#button-login{

} 
.nav-bar{
  padding-left: 50px;;
}
.link{
  padding-right:100px;
  font-size: 20px;
  color:white;
}

.error {
  text-align: center;
  color: red;
  padding-top: 20px;
}
</style>